/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_1_TitleInputs */

const en_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Player Development Award`)
};

const es_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio al Desarrollo de Jugadores de la Iowa PGA`)
};

const de_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielerentwicklungspreis der Iowa PGA`)
};

const zh_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 球员培养奖`)
};

const ar_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزة تطوير اللاعبين من Iowa PGA`)
};

const fr_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix du développement des joueurs de la Iowa PGA`)
};

const vi_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải thưởng Phát triển Cầu thủ của Iowa PGA`)
};

const sw_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuzo ya Iowa PGA ya Kukuza Wachezaji`)
};

const th_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลพัฒนานักกอล์ฟของ Iowa PGA`)
};

const bs_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrada Iowa PGA za razvoj igrača`)
};

const ja_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 選手育成賞`)
};

const ko_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 선수 육성상`)
};

const pt_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmio de Desenvolvimento de Jogadores da Iowa PGA`)
};

const it_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio per lo sviluppo dei giocatori della Iowa PGA`)
};

const sv_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:s pris för spelarutveckling`)
};

const nl_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelersontwikkelingsprijs van de Iowa PGA`)
};

const da_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA's pris for spillerudvikling`)
};

const nb_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGAs spillerutviklingspris`)
};

const fi_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n pelaajakehityspalkinto`)
};

const pl_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagroda Iowa PGA za rozwój zawodników`)
};

const ru_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премия Iowa PGA за развитие игроков`)
};

const tr_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Oyuncu Geliştirme Ödülü`)
};

const hi_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA खिलाड़ी विकास पुरस्कार`)
};

const id_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan Pengembangan Pemain Iowa PGA`)
};

const ms_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anugerah Pembangunan Pemain Iowa PGA`)
};

const cs_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena Iowa PGA za rozvoj hráčů`)
};

const el_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βραβείο ανάπτυξης παικτών της Iowa PGA`)
};

const he_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרס פיתוח שחקנים של Iowa PGA`)
};

const af_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA-toekenning vir spelerontwikkeling`)
};

const hu_about_content_honor_0_item_1_title = /** @type {(inputs: About_Content_Honor_0_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA játékosfejlesztési díja`)
};

/**
* | output |
* | --- |
* | "Iowa PGA Player Development Award" |
*
* @param {About_Content_Honor_0_Item_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_1_title = /** @type {((inputs?: About_Content_Honor_0_Item_1_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_1_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_1_title(inputs)
	if (locale === "de") return de_about_content_honor_0_item_1_title(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_1_title(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_1_title(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_1_title(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_1_title(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_1_title(inputs)
	if (locale === "th") return th_about_content_honor_0_item_1_title(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_1_title(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_1_title(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_1_title(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_1_title(inputs)
	if (locale === "it") return it_about_content_honor_0_item_1_title(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_1_title(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_1_title(inputs)
	if (locale === "da") return da_about_content_honor_0_item_1_title(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_1_title(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_1_title(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_1_title(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_1_title(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_1_title(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_1_title(inputs)
	if (locale === "id") return id_about_content_honor_0_item_1_title(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_1_title(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_1_title(inputs)
	if (locale === "el") return el_about_content_honor_0_item_1_title(inputs)
	if (locale === "he") return he_about_content_honor_0_item_1_title(inputs)
	if (locale === "af") return af_about_content_honor_0_item_1_title(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_1_title(inputs)
	return en_about_content_honor_0_item_1_title(inputs)
});